// Whether the window is at least `minPx` wide, following resizes. False where `matchMedia` is
// missing (tests), so layouts fall back to their narrow form.
import { useSyncExternalStore } from "react";

export function useWideScreen(minPx = 768): boolean {
  const query = `(min-width: ${minPx}px)`;
  return useSyncExternalStore(
    (notify) => {
      if (typeof matchMedia !== "function") return () => {};
      const list = matchMedia(query);
      list.addEventListener("change", notify);
      return () => list.removeEventListener("change", notify);
    },
    () => typeof matchMedia === "function" && matchMedia(query).matches,
    () => false,
  );
}
